/* eslint-disable no-unused-vars */

export enum DownloadStatus {
    NOT_DOWNLOADED,
    DOWNLOADING,
    DOWNLOADED
}
